import { forwardRef } from "react";
import { cn } from "../../lib/cn";

export interface ListGroupProps extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Inset card-shaped group — children are ListItems/ListItemButtons separated
 * by hairline dividers. Same border + elevation treatment as Card so grouped
 * lists and cards read as one surface family.
 */
export const ListGroup = forwardRef<HTMLDivElement, ListGroupProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "mx-4 my-2 divide-y divide-border-default overflow-clip rounded-xl border border-border-default bg-surface-default shadow-card",
          className,
        )}
        {...props}
      />
    );
  },
);
ListGroup.displayName = "ListGroup";
